export default "__VITE_ASSET__BEUo1wfh__"